import React, { useMemo } from 'react'
import { Affix, Layout, Row, Col, Menu, Button, Dropdown } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { clearFirmLogin } from '../store/firmLoginSlice'
import classes from './home.module.css'
import Foot from './Foot'
import { LogoutOutlined, ShoppingOutlined, UserOutlined, KeyOutlined } from '@ant-design/icons'
const { Content,} = Layout;

function WebMain(props) {
    const navi = useNavigate()
    const dispatch = useDispatch()
    const firmLogin = useSelector((state) => state.firmLogin)
    const isFirmLogged = Boolean(firmLogin?.isLog)
    const displayEntName = firmLogin?.byxkh_yh_kh_name || '企业用户'
    const displayUserName = firmLogin?.byxkh_yh_name || '--'
    const displayPhone = firmLogin?.byxkh_yh_phone || '--'
    const userMenuItems = useMemo(
        () => [
           
            {
                key: 'order',
                label: '订单',
                icon: <ShoppingOutlined />,
                onClick: () => {
                    navi('/FirmOrderList')
                }
            },
            {
                key: 'user',
                label: '用户',
                icon: <UserOutlined />,
                onClick: () => {
                    navi('/FirmUserList')
                }
            },
            {
                key: 'password',
                label: '修改密码',
                icon: <KeyOutlined />,
                onClick: () => {
                    navi('/FirmUserPassword')
                }
            },
            {
                key: 'logout',
                label: '退出登录',
                icon: <LogoutOutlined />,
                onClick: () => {
                    dispatch(clearFirmLogin())
                    navi('/', { replace: true })
                }
            },
        ],
        [dispatch, navi]
    )
    const items = [       
        {
            label: '首页',
            key: 'product',
        },       
        {
            label: '定制案例',
            key: 'goods',
        },       
     
        {
            label: '关于我们',
            key: 'about',
        },      
          
        {
            label: '联系我们',
            key: 'contact',
        },                   
    ]
    return (
        <Layout>
            <Affix offsetTop='0'>
                <Row style={{color:'#fff',backgroundColor:"#000000"}}>
                    <Col span={3} >
                        <div 
                            className={classes.mainHeaderLogo}
                            onClick={() => {
                                navi('/')
                            }}
                        >
                            <div>伯纳思</div>
                        </div>
                    </Col>                                     
                    <Col span={18} style={{display:'flex',alignItems:'center',justifyContent:'center'}}>                       
                        {props.selectedKeys && <Menu 
                            items={items} 
                            mode='horizontal'
                            theme="dark"
                            onClick={(e) => {
                                switch (e.key) {                                  
                                    case 'product':
                                        navi('/')
                                        break;
                                    case 'goods':
                                        navi('/WebGoods')
                                        break;
                                    case 'demo':
                                        navi('/DemoIndex')
                                        break;
                                        
                                    case 'about':
                                        navi('/WebAbout')
                                        break;
                                    case 'news':
                                        navi('/WebNews')
                                        break;
                                    case 'contact':
                                        navi('/Service')
                                        break;    
                                    case 'firm':
                                        navi('/FirmHome')
                                        break;    
                                    default:
                                        break;
                                }                        
                            }}
                            style={{
                                fontSize:"22px",
                                width:"880px",
                                marginLeft:"100px",
                                color: "#fff",
                                backgroundColor: "transparent",
                            }}
                            selectedKeys={props.selectedKeys}
                            
                        /> }        
                    </Col>                                     
                    <Col span={3} style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                        {props.selectedKeys !== '/FirmLogin' && (
                            isFirmLogged ? (
                                <Dropdown
                                    menu={{
                                        items: userMenuItems,
                                        onClick: ({ key }) => {
                                            if (key !== 'logout') return
                                            dispatch(clearFirmLogin())
                                            navi('/FirmLogin', { replace: true })
                                        },
                                    }}
                                    placement='bottomRight'
                                    trigger={['click']}
                                >
                                    <a style={{color:'#fff'}}>
                                      {displayEntName} - {displayUserName} - {displayPhone}
                                    </a>
                                </Dropdown>
                            ) : (
                                <Button type='primary' onClick={() => {
                                    navi('/FirmLogin')
                                }}>登录</Button>
                            )
                        )}
                    </Col> 
                </Row>
            </Affix>
            <Content
                style={{ 
                    background: '#fff', 
                    position: 'relative', 
                    zIndex: 1,
                    marginTop: -2 // 根据需要调整这个值让内容上移
                }}
            >
                {props.children}
            </Content>
            <Foot/>
        </Layout>
    )
}

export default WebMain